export default "<p>\r\n  entregas-parciales works!\r\n</p>\r\n"